export class NotebookExecutionResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "executionId",
            "baseName": "executionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "NotebookExecutionResultStatusEnum",
            "format": ""
        },
        {
            "name": "outputs",
            "baseName": "outputs",
            "type": "Array<NotebookExecutionOutput>",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NotebookExecutionResult.attributeTypeMap;
    }
    constructor() {
    }
}
export var NotebookExecutionResultStatusEnum;
(function (NotebookExecutionResultStatusEnum) {
    NotebookExecutionResultStatusEnum["NOTEBOOK_EXECUTION_STATUS_RUNNING"] = "running";
    NotebookExecutionResultStatusEnum["NOTEBOOK_EXECUTION_STATUS_COMPLETED"] = "completed";
    NotebookExecutionResultStatusEnum["NOTEBOOK_EXECUTION_STATUS_ERROR"] = "error";
    NotebookExecutionResultStatusEnum["NOTEBOOK_EXECUTION_STATUS_NOT_FOUND"] = "not_found";
})(NotebookExecutionResultStatusEnum || (NotebookExecutionResultStatusEnum = {}));
